// extracted by mini-css-extract-plugin
export default {"brandPromo":"FE-z","carousel":"GE-z"};